import { render, staticRenderFns } from "./chapter.vue?vue&type=template&id=1be8315c&scoped=true&xmlns%3A=true"
import script from "./chapter.vue?vue&type=script&lang=js"
export * from "./chapter.vue?vue&type=script&lang=js"
import style0 from "./chapter.vue?vue&type=style&index=0&id=1be8315c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be8315c",
  null
  
)

export default component.exports